var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._v(" 404 错误 页面不存在 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }